import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button } from "grommet";
import * as React from "react";
import { useNavigate, useParams } from "react-router-dom";
import SeasonDetails from "./SeasonDetails";
import { createSeason, CreateSeasonRequest } from "./SeasonsStore";

const plus = <FontAwesomeIcon icon={["fad", "plus"]}></FontAwesomeIcon>;
const xmark = <FontAwesomeIcon icon={["fad", "xmark"]}></FontAwesomeIcon>;

const CreateSeason = () => {
    let [season, setSeason] = React.useState(new CreateSeasonRequest());

    let [isCreating, setIsCreating] = React.useState(false);

    let [error, setError] = React.useState("");

    let { leagueID } = useParams<{ leagueID: string }>();

    const navigate = useNavigate();

    let create = () => {
        setIsCreating(true);
        createSeason({ ...season, leagueID }).then(
            (result) => {
                navigate(`/seasons/${result.seasonID}`);
            },
            (error) => {
                setError(error);
            }
        );
    };

    const onChange = (updatedSeason) => {
        setSeason({ ...season, ...updatedSeason });
    };

    return (
        <div>
            <h1>Create Season</h1>
            <Box>
                <SeasonDetails season={season} isBusy={isCreating} onChange={onChange}></SeasonDetails>
                <Button primary onClick={create} disabled={isCreating || !season.name} label="Create"></Button>
                <Box>{error && <pre>{JSON.stringify(error, null, 2)}</pre>}</Box>
            </Box>
        </div>
    );
};

export default CreateSeason;
